export default __webpack_public_path__ + "static/media/SViewIconWhite.cc52e793.svg";